import { render, staticRenderFns } from "./Step8.vue?vue&type=template&id=5aa7d9aa&scoped=true"
import script from "./Step8.vue?vue&type=script&lang=js"
export * from "./Step8.vue?vue&type=script&lang=js"
import style0 from "./Step8.vue?vue&type=style&index=0&id=5aa7d9aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa7d9aa",
  null
  
)

export default component.exports